var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { Button, Header, Message, Table } from "semantic-ui-react";
import { downloadBlob } from "../download";
import UploadFileModal from "./UploadFileModal";
var BindingSitesModal = /** @class */ (function (_super) {
    __extends(BindingSitesModal, _super);
    function BindingSitesModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Exports only the site number and the full/odd/even binding-site sequences (no probe seqs, positions, or
        // onTargetFrac). Generated client-side from the binding sites already in props.
        _this.downloadCsv = function () {
            var escape = function (v) {
                return /[",\n]/.test(v) ? "\"" + v.replace(/"/g, '""') + "\"" : v;
            };
            var header = ['Site', 'Binding Site', 'Odd Site', 'Even Site'];
            var rows = __spreadArrays(_this.props.bindingSites).sort(function (a, b) { return a.siteNumber - b.siteNumber; })
                .map(function (bs) { return [
                bs.siteNumber.toString(),
                escape(bs.bindingSiteSeq),
                escape(bs.oddSite),
                escape(bs.evenSite),
            ].join(','); });
            var csv = __spreadArrays([header.join(',')], rows).join('\n');
            downloadBlob("binding_sites_variant_" + _this.props.variantId + ".csv", csv, 'text/csv;charset=utf-8');
        };
        _this.abbreviate = function (seq) {
            if (seq.length <= 20)
                return seq;
            return seq.substring(0, 17) + '...';
        };
        return _this;
    }
    BindingSitesModal.prototype.render = function () {
        var _this = this;
        var bindingSites = this.props.bindingSites;
        var orgId = this.props.orgId;
        var psfId = this.props.psfId;
        var variantId = this.props.variantId;
        var hasSites = bindingSites.length > 0;
        var uploadPath = "/admin/catalog/rna/organisms/id/" + encodeURIComponent(orgId.toString()) + "/probe-set-families/id/" + encodeURIComponent(psfId.toString()) + "/variants/id/" + encodeURIComponent(variantId.toString()) + "/binding-sites";
        return React.createElement(React.Fragment, null,
            hasSites && React.createElement(React.Fragment, null,
                React.createElement(Header, { size: 'small' },
                    "Current Binding Sites (",
                    bindingSites.length,
                    ")"),
                React.createElement(Button, { size: 'small', icon: 'download', content: 'Download CSV', labelPosition: 'left', style: { marginBottom: '0.5em' }, onClick: this.downloadCsv }),
                React.createElement("div", { style: { maxHeight: '400px', overflowY: 'auto' } },
                    React.createElement(Table, { celled: true, compact: true, size: 'small' },
                        React.createElement(Table.Header, null,
                            React.createElement(Table.Row, null,
                                React.createElement(Table.HeaderCell, null, "#"),
                                React.createElement(Table.HeaderCell, null, "Start"),
                                React.createElement(Table.HeaderCell, null, "End"),
                                React.createElement(Table.HeaderCell, null, "On Target"),
                                React.createElement(Table.HeaderCell, null, "Binding Site Seq"),
                                React.createElement(Table.HeaderCell, null, "Odd Site"),
                                React.createElement(Table.HeaderCell, null, "Even Site"),
                                React.createElement(Table.HeaderCell, null, "Probe Seq"),
                                React.createElement(Table.HeaderCell, null, "Odd Probe"),
                                React.createElement(Table.HeaderCell, null, "Even Probe"))),
                        React.createElement(Table.Body, null, bindingSites.map(function (bs) {
                            return React.createElement(Table.Row, { key: bs.id },
                                React.createElement(Table.Cell, null, bs.siteNumber),
                                React.createElement(Table.Cell, null, bs.startPos),
                                React.createElement(Table.Cell, null, bs.endPos),
                                React.createElement(Table.Cell, null, bs.onTargetFrac != null ? bs.onTargetFrac.toFixed(4) : ''),
                                React.createElement(Table.Cell, null, _this.abbreviate(bs.bindingSiteSeq)),
                                React.createElement(Table.Cell, null, _this.abbreviate(bs.oddSite)),
                                React.createElement(Table.Cell, null, _this.abbreviate(bs.evenSite)),
                                React.createElement(Table.Cell, null, _this.abbreviate(bs.probeSeq)),
                                React.createElement(Table.Cell, null, _this.abbreviate(bs.oddProbe)),
                                React.createElement(Table.Cell, null, _this.abbreviate(bs.evenProbe)));
                        }))))),
            !hasSites &&
                React.createElement(Message, { info: true }, "No binding sites for this variant."),
            React.createElement(Header, { size: 'small' }, hasSites ? 'Replace Binding Sites' : 'Import Binding Sites'),
            React.createElement("p", { style: { color: 'grey', fontSize: '0.9em' } },
                "Upload the designer's Compare workbook (.xlsx) for this variant. Rows with Selected = Y or Manually Add Probe = Y become the binding sites (Candidate Number, fullTGT, fullRC, oddRC, evenRC); their count must equal the variant's probe set size and each site must occur in the target sequence.",
                hasSites && ' Existing sites are replaced.'),
            React.createElement(UploadFileModal, { path: uploadPath }));
    };
    return BindingSitesModal;
}(React.PureComponent));
export default BindingSitesModal;
//# sourceMappingURL=BindingSitesModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/BindingSitesModal.js
// module id = 1458
// module chunks = 0